// ═══════════════════════════════════════════════════════════
// Navbar Component — شريط التنقل
// Fixed navigation bar with scroll spy, mobile menu,
// and dark/light mode toggle
// ═══════════════════════════════════════════════════════════

import React, { useState, useEffect } from 'react';
import '../styles/Navbar.css';

// Navigation items — Poetry removed, Books renamed to الإصدارات
const NAV_ITEMS = [
  { id: 'home', labelAr: 'الرئيسية', labelEn: 'Home' },
  { id: 'about', labelAr: 'السيرة', labelEn: 'About' },
  { id: 'books', labelAr: 'الإصدارات', labelEn: 'Books' },
  { id: 'munfaridat', labelAr: 'قصائد متنوعة', labelEn: 'Singles' },
  { id: 'videos', labelAr: 'مرئيات', labelEn: 'Videos' },
  { id: 'events', labelAr: 'الفعاليات', labelEn: 'Events' },
  { id: 'contact', labelAr: 'تواصل', labelEn: 'Contact' },
];

function Navbar({ darkMode, setDarkMode }) {
  const [activeSection, setActiveSection] = useState('home');
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      const sections = NAV_ITEMS.map(item => item.id);
      for (const sectionId of sections) {
        const element = document.getElementById(sectionId);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 150 && rect.bottom > 150) {
            setActiveSection(sectionId);
            break;
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  useEffect(() => {
    const handleEscape = (e) => { if (e.key === 'Escape') setMenuOpen(false); };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`} role="navigation" aria-label="القائمة الرئيسية">
      <div className="navbar__container">
        <div className="navbar__logo" onClick={() => scrollToSection('home')} role="button" tabIndex={0} aria-label="العودة للرئيسية">
          <div className="navbar__logo-icon">و</div>
          <span className="navbar__logo-text">الشاعر وجدي عبد الصمد</span>
        </div>

        <div className="navbar__links">
          {NAV_ITEMS.map(item => (
            <button
              key={item.id}
              className={`navbar__link ${activeSection === item.id ? 'navbar__link--active' : ''}`}
              onClick={() => scrollToSection(item.id)}
              title={item.labelEn}
              aria-label={`${item.labelAr} - ${item.labelEn}`}
            >
              {item.labelAr}
            </button>
          ))}
          <button
            className="navbar__theme-toggle"
            onClick={() => setDarkMode(!darkMode)}
            aria-label={darkMode ? 'تفعيل الوضع الفاتح' : 'تفعيل الوضع الداكن'}
            title={darkMode ? 'Light Mode' : 'Dark Mode'}
          >
            <span className="navbar__theme-icon">{darkMode ? '☀️' : '🌙'}</span>
            <span className="navbar__theme-label">{darkMode ? 'فاتح' : 'داكن'}</span>
          </button>
        </div>

        <button className="navbar__mobile-toggle" onClick={() => setMenuOpen(!menuOpen)} aria-label={menuOpen ? 'إغلاق القائمة' : 'فتح القائمة'} aria-expanded={menuOpen}>
          <div className={`navbar__hamburger ${menuOpen ? 'navbar__hamburger--open' : ''}`}>
            <span></span><span></span><span></span>
          </div>
        </button>
      </div>

      {menuOpen && (
        <div className="navbar__mobile-menu" role="menu">
          {NAV_ITEMS.map(item => (
            <button key={item.id} className={`navbar__mobile-link ${activeSection === item.id ? 'navbar__mobile-link--active' : ''}`} onClick={() => scrollToSection(item.id)} role="menuitem">
              <span className="navbar__mobile-link-ar">{item.labelAr}</span>
              <span className="navbar__mobile-link-en">{item.labelEn}</span>
            </button>
          ))}
          <button className="navbar__mobile-link navbar__mobile-theme" onClick={() => { setDarkMode(!darkMode); setMenuOpen(false); }} role="menuitem">
            {darkMode ? '☀️ الوضع الفاتح' : '🌙 الوضع الداكن'}
          </button>
        </div>
      )}
    </nav>
  );
}

export default Navbar;